import { useConfigNegocio } from './useConfigNegocio';
import {
  CategoriaMovimiento, parseCategoriasMovimiento, categoriasDe,
  categoriaDefault, labelCategoria, emojiCategoria,
} from '../constants/movimientos';

/**
 * Categorías de movimiento de caja configuradas en Configuración › Movimientos de caja,
 * con los helpers ya "atados" a la lista vigente para no andar pasándola en
 * cada llamada. Si el admin agrega "Renta", aparece sola en Caja y en el
 * reporte sin tocar código.
 */
export function useCategoriasMovimiento() {
  const config = useConfigNegocio();
  const categorias: CategoriaMovimiento[] = parseCategoriasMovimiento(config.movimientos_categorias);

  return {
    categorias,
    deTipo:  (tipo: 'retiro' | 'deposito') => categoriasDe(categorias, tipo),
    defecto: (tipo: 'retiro' | 'deposito') => categoriaDefault(categorias, tipo),
    label:   (v?: string) => labelCategoria(categorias, v),
    emoji:   (v?: string) => emojiCategoria(categorias, v),
  };
}
